/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateOfBirth/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import Copy from 'DesignSystem/Copy/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function DateOfBirth({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/SignAction/Content/Content/Password/DateOfBirth"
  
}) {
let dateOfBirthValueData = fromData.useDataFormat({ viewPath,
context: 'date_of_birth',
format: fromFormat.dateISOIn,
})
let dateOfBirthValueData1 = fromData.useDataFormat({ viewPath,
context: 'date_of_birth',
format: fromFormat.dateISOIn,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="date_of_birth"
 format="/Data/format.js dateISOIn"
 text={dateOfBirthValueData}
 size="normal"
 weight="medium"
/>
<Copy
  viewPath={`${viewPath}/Copy`}
 marginLeft={0}
 data="date_of_birth"
 format="/Data/format.js dateISOIn"
 value={dateOfBirthValueData1}
 text="Copy date of birth"
/>
{children}
</React.Fragment>)
}